import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import { createPinia } from 'pinia'
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";



// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBNq8Kpwih0_Jg-aOayoufNtN6qPju77Qc",
  authDomain: "auth.cloudamai.com",
  projectId: "cloudamaibasecore",
  storageBucket: "cloudamaibasecore.firebasestorage.app",
  messagingSenderId: "323820207756",
  appId: "1:323820207756:web:da050e245cb35db4d745a9"
};
// Activate when in dev

const firebaseConfigDev = {
  projectId: "cloudamaibasecore",
    authDomain: "cloudamaibasecore.firebaseapp.com",
};


// Initialize Firebase
const fbapp = initializeApp(firebaseConfig);
export const auth = getAuth(fbapp);
export const db = getFirestore(fbapp);
if (window.location.hostname === "localhost") {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8080)
}



import App from './App.vue'
import router from './router'
// import i18n from './i18n'

import './assets/index.postcss'
import "preline/preline"

// Import Easy Data table
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { faGear } from '@fortawesome/free-solid-svg-icons'
import { faFilm } from '@fortawesome/free-solid-svg-icons'
import { faComment } from '@fortawesome/free-solid-svg-icons'
import { faMusic } from '@fortawesome/free-solid-svg-icons'
import { faFaceLaughWink } from '@fortawesome/free-solid-svg-icons'
import { faClosedCaptioning } from '@fortawesome/free-solid-svg-icons'
import { faUserPen } from '@fortawesome/free-solid-svg-icons'


/* add icons to the library */
library.add(faGear)
library.add(faFilm)
library.add(faMusic)
library.add(faComment)
library.add(faFaceLaughWink)
library.add(faClosedCaptioning)
library.add(faUserPen)

const head = createHead()
const app = createApp(App)

app.use(router)
// app.use(i18n)
app.use(head)
app.use(createPinia())
app.component('font-awesome-icon', FontAwesomeIcon)
app.component('EasyDataTable', Vue3EasyDataTable);

app.mount('#app')
